const normalizeExpenses = (expenses) => {
  if (Array.isArray(expenses)) {
    return expenses;
  }
  if (expenses && Array.isArray(expenses.expenses)) {
    return expenses.expenses;
  }
  return [];
};

export const calculateTotals = (expenses, currencyView = 'BaseCurrency') => {
  let income = 0;
  let expense = 0;
  const normalizedExpenses = normalizeExpenses(expenses);

  normalizedExpenses.forEach((exp) => {
    const amount = Number(exp?.amount) || 0;
    const rate = Number(exp?.conversionRate) || 1;
    const value =
      currencyView === 'BaseCurrency' ? amount / rate : amount;
    if (exp?.type === 'income') {
      income += value;
    } else if (exp?.type === 'expense') {
      expense += value;
    }
  });

  const netProfit = income - expense;
  return {income, expense, netProfit};
};
